<template>
  <div class="shadow grid-stack-item-content tasks-tool h-100">
    <b-card class="flex-container" no-body>
      <div slot="header">
        <window-header cmp-title="Tasks" widget-name="tasks">
          <template slot="options">
            <b-button :pressed.sync="showModal" size="sm" variant="dark" type="dark" class="headerSmallButton"><icon name="plus" scale=".7"></icon></b-button>
          </template>
        </window-header>
      </div>
      <div class="window-body">
        <b-table hover small :items="tasks" :fields="fields">
          <template slot="has_file" slot-scope="data">
            <span v-show="data.item.process_state === 'success'" v-html="getDownloadLink(data.item)"></span>
          </template>
          <template slot="actions" slot-scope="data">
            <b-dropdown size="sm" text="Actions" variant="link">
              <b-dropdown-item @click="deleteTasks([data.item.id])" href="#">Delete</b-dropdown-item>
              <b-dropdown-item @click="viewLogs(data)" href="#">View logs</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </div>
      <window-footer></window-footer>

    </b-card>

    <b-modal :title="logsTitle" v-model="shownLogs" size="lg" id="task-log-modal">
      <div id="log-container">
        <p v-html="logs"></p>
      </div>
    </b-modal>
    <b-modal title="Add Tasks" @ok="addTasks" v-model="showModal" id='task-new-modal'>
      <b-list-group>
        <b-list-group-item v-for="s in scripts" :key="s.id">
          <b-form-checkbox v-model="tasksToAdd[s.id]" :value="s.id">{{s.name.replace(/\{\w+\}/g, '')}}</b-form-checkbox>
          <file-uploader :scriptId="s.id" ref="fUploader"  v-if="s.file_path_arg" v-model="inputFiles[s.id]"></file-uploader>
          <template v-if="s.predefined_params">
            <div v-for="pp in JSON.parse(s.predefined_params)" :key="pp.name">
               <list v-if="pp.type === 'list'" v-model="predefinedParams[s.id+'~'+pp.name]" :values="pp.values" :labels="pp.labels || pp.values"></list>
               <b-form-select v-if="pp.type === 'custom_list' && pp.tag === 'workpack_list'" v-model="predefinedParams[s.id+'~'+pp.name]" :options="workpackList"></b-form-select>
            </div>
          </template>
          <template v-if="s.by_batch">
            <div>
              <b-form-select :options="batch_zones" v-model="selected_batch_zone" placeholder="Please, select option"></b-form-select>
            </div>
          </template>
          <template v-if="s.by_config">
            <div>
              <b-form-select :options="valve_configs" v-model="selected_valve_config" placeholder="Please, select option"></b-form-select>
            </div>
          </template>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>
<script>
  import 'vue-awesome/icons/plus'
  import Vue from 'vue'
  import store from '../../store'
  import WindowHeader from '../common/WindowHeader'
  import WindowFooter from '../common/WindowFooter'

  import FileUploader from '../FileUploader'
  import List from './task_input/List'


  export default {
    name: 'task-list',
    components: {List, FileUploader, WindowHeader, WindowFooter},
    data () {
      return {
        addAllowed: true,
        showModal: false,
        tasksToAdd: {},
        logs: '',
        batch_zones: [],
        valve_configs: [],
        selected_batch_zone : 0,
        selected_valve_config : 0,
        logsTitle: '',
        shownLogs: false,
        tasks: [],
        // bootstrap-vue 2.23 b-table requires `fields` as an Array (object form removed) — 2026-05-29
        fields: [
          { key: 'name', label: 'Name' },
          { key: 'process_state', label: 'Status' },
          { key: 'date_completed', label: 'Completed' },
          { key: 'user_added', label: 'User' },
          { key: 'workpack_id', label: 'Workpack' },
          { key: 'has_file', label: 'File' },
          { key: 'actions', label: 'Actions' }
        ],
        scripts: [],
        inputFiles: {

        },
        predefinedParams: {

        }
      }
    },
    computed: {
      workpackList () {
        let list = []
        let fn = (p) => {
          if (p.workpack) {
            list.push(
              {
                text: `${p.workpack.id} (${p.name})`,
                value: p.workpack.id
              }
            )
          }


          if (p.children) {
            p.children.forEach(fn)
          }
        }

        this.$store.getters['project/projects'].forEach(p => {
          fn(p)
        })

        return list


      },
      enabled () {
        return this.$store.getters['cmp/all']['tasks']['enabled']
      },
      currentProject () {
        return store.getters['project/currentProject']
      }
    },
    watch: {
      enabled (val) {
        if (val) {
          this.taskRefresh()
        }
      },
      currentProject () {
        this.taskRefresh()
        this.loadScripts()
      },
      tasksToAdd: {
        handler: function () {
          this.validateInputFiles()
        },
        deep: true
      },
      inputFiles: {
        handler: function () {
          this.validateInputFiles()
        },
        deep: true
      }
    },
    methods: {
      validateInputFiles () {
        this.addAllowed = true
        Object.keys(this.tasksToAdd).forEach(k => {
          if (this.tasksToAdd[k] && typeof this.inputFiles[k] !== 'undefined' && !this.inputFiles[k]) {
            this.addAllowed = false
          }
        })
      },
      viewLogs (rec) {
        this.shownLogs = true
        this.logsTitle = 'Logs for ' + rec.item.name
        this.$tasksService.get_logs(rec, this)
      },
      getDownloadLink (item) {
        let label = 'download'
        if (item.script_id === 200 ) {
          label = 'go to modeller'
        }
        return item.has_file ? '<a target="_blank" href="/api/tasks/download/' + item.id + '">'+label+'</a>' : ''
      },
      loadTasks (clb) {
        if (!this.enabled) {
          clb(null, [])
          return
        }
        this.$http.get('/api/tasks/list', {
          params: {
            workpack_id: this.currentProject.workpack.id
          }
        })
          .then(res => {
            res.body.map(t => {
              if (/\{\w+\}/.test(t.name) && t.params) {
                let params = JSON.parse(t.params)
                t.name = t.name.replace(/\{(\w+)\}/g, (m, k, v) => {
                  return params[k]
                })
              }
              return t;
            })
            clb(null, res.body)
          }, res => clb('Could not load tasks'))
      },
      loadBatchZones () {
        this.batch_zones = []
        this.$http.get('/api/layers/get-batch-zones', {
          params: {
            workpack_id: this.currentProject.workpack.id
          }
        }).then(res => {
              res.body.forEach(t =>
                this.batch_zones.push({text: t.batch_name, value: t.gid})
              )
              if (this.batch_zones.length) {
                this.selected_batch_zone = this.batch_zones[0].value
                this.batch_zones.sort(function(a, b){
                    if(a.text < b.text) { return -1; }
                    if(a.text > b.text) { return 1; }
                    return 0;
                })
              }
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load batch zones',
              type: 'error'
            })
          })
      },
      loadValveConfigs () {
        this.valve_configs = []
        this.$http.get('/api/layers/get-valve-configs')
          .then(res => {
            res.body.forEach(t =>
              this.valve_configs.push({text: t.config_name, value: parseInt(t.id)})
            )
            if (this.valve_configs.length) {
              this.valve_configs.sort(function(a, b){
                  if(a.value < b.value) { return -1; }
                  if(a.value > b.value) { return 1; }
                  return 0;
              })
              this.selected_valve_config = this.valve_configs[0].value
            }
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load valve configs',
              type: 'error'
            })
          })
      },
      loadScripts () {
        this.$tasksService.loadScripts(this, scripts => {
          scripts = scripts.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() && 1 || -1)
          scripts.forEach(s => {
            if (s.file_path_arg) {
              Vue.set(this.inputFiles, s.id, '')
              Vue.set(this.tasksToAdd, s.id, false)
            }
          })
        })
      },
      taskRefresh () {

        this.loadTasks((err, tasks) => {
          if (err) {
            console.error(err)
          }
          console.log('tasks')
          this.setTasks(tasks)
          if (this.enabled) {
            setTimeout(this.taskRefresh, 3000)
          }
        })
      },
      setTasks (tasks) {
        tasks = tasks.map(t => {
          if (t.date_completed) {
            let d = new Date(t.date_completed)
            t.date_completed = d.toLocaleDateString() + ' ' + d.toLocaleTimeString()
          }
          if (t.process_state === 'success') {
            t._rowVariant = 'success'
          }

          if (t.process_state === 'error') {
            t._rowVariant = 'danger'
          }

          if (t.process_state === 'progress') {
            t._rowVariant = 'info'
          }

          return t
        })
        this.tasks = tasks
      },
      deleteTasks (ids) {
        let url = '/api/tasks/delete-tasks'
        let payload = {'ids': ids}
        this.$http.post(url, payload)
          .then(res => {
            this.$notify({
              title: 'SUCCESS',
              text: 'Task delete.',
              type: 'success'
            })
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not delete task.',
              type: 'error'
            })
          })
      },
      addTasks (bvEvt) {
        if (!Object.keys(this.tasksToAdd).length) {
          this.$notify({
            title: 'No tasks',
            text: 'Please, choose tasks.',
            type: 'warning'
          })
          bvEvt.preventDefault()
        }
        if (!this.addAllowed) {
          this.$notify({
            title: 'Upload files',
            text: 'Some tasks expect input files, please provide them.',
            type: 'warning'
          })
          bvEvt.preventDefault()
          return false
        }
        let payload = {}
        payload['ids'] = Object.keys(this.tasksToAdd).filter(k => this.tasksToAdd[k]).map(id => {

          let p = {
            'id': parseInt(id),
            'params': {}
          }

          let s = this.scripts.filter(s =>s.file_path_arg && s.id === parseInt(id))[0]
          s && (p['params'][s.file_path_arg] = this.inputFiles[s.id].split(',')[0])

          s = this.scripts.filter(s =>s.id === parseInt(id))[0]

          if (s.predefined_params) {
            JSON.parse(s.predefined_params).forEach(pp => {
              let key = Object.keys(this.predefinedParams).filter(ok => ok === id+'~'+pp.name)[0]
              if (key) {
                p['params'][pp.name] = this.predefinedParams[key]
              }
            })
          }

          return p
        })
        payload['project_id'] = this.currentProject.id
        payload['workpack_id'] = this.currentProject.workpack.id


        let batch = this.batch_zones.find(b => b.value === this.selected_batch_zone)
        let valve_config = this.valve_configs.find(b => b.value === this.selected_valve_config)

        if (batch) {
          payload['batch'] = this.selected_batch_zone
          payload['batch_name'] = batch.text
        }
        if (valve_config) {
          payload['config'] = this.selected_valve_config
          payload['config_name'] = valve_config.text
        }

        this.$tasksService.addTasks(this, payload)

        Object.keys(this.tasksToAdd).forEach(k => this.tasksToAdd[k] = false)
        Object.keys(this.inputFiles).forEach(k => this.inputFiles[k] = '')

        Object.keys(this.inputFiles).forEach(k => {
          console.log(`broadcasting ${k}`)
          this.$bus.$emit('uploader-clean', parseInt(k))
        })
      }
    },
    mounted () {

      this.loadBatchZones()
      this.loadValveConfigs()
      this.taskRefresh()
      this.loadScripts()
    },
    props: {
      shown: {
        default: false
      }
    }
  }
</script>
<style lang="scss">
  .task-list {
    display: flex;
    flex-flow: column;
    height: 100%;
  }

  .task-list-content {
    flex: 2;
    overflow: auto;
  }

  .task-container {
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/map/TasksTool.vue